import {SignIn} from '@clerk/clerk-react'
import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute('/sign-in')({
	component: SignInPage,
})

function SignInPage() {
	return (
		<div className='flex justify-center items-center h-screen'>
			<SignIn />
		</div>
	)
}
